module.exports = "/_next/static/images/4f751fc441dc485f0bf0d4007f9c080a-logo-fondo-ahorro-xs.png";